import type { VfConfig } from '#types/config/components/vf'

export default {
  brandClasses: {
    carousel: 'gap-1 bg-white',
    pagination: 'lg:hidden'
  },
  showPagination: true
} satisfies VfConfig['mediaGallery']
